/**
 * Área FICHA · MANUAL FOTO MODELO: as respostas que a cliente preencheu no portal dela.
 *
 * Só leitura, como no legado (`admin.html:5244`, "Só leitura. Quem preenche é a cliente"). A foto
 * enviada abre por link assinado, que vem de `ficha-arquivos.ts` (`gerarLinkAssinado`).
 */

// Tudo que uma área usa vem do núcleo, e de mais lugar nenhum (ver PADRAO.md).
import {
  clienteDe,
  comEscopo,
  executar,
  type Escopo,
  type FonteDeDados,
  type LinhaManualFotoRespostas,
  type Resultado,
} from '../nucleo.js';

/**
 * Lê as respostas do manual de foto na ficha aberta.
 * Legado: `admin.html:5248`, `comEscopo(sb.from('manual_foto_respostas').select('*')).maybeSingle()`.
 *
 * `dados` nulo é "Cliente ainda não respondeu.", e não falha.
 */
export function lerManualFoto(fonte: FonteDeDados, escopo: Escopo): Promise<Resultado<LinhaManualFotoRespostas | null>> {
  // O escopo filtra a cliente e, com lead aberto, o lead.
  return executar<LinhaManualFotoRespostas | null>(
    comEscopo(clienteDe(fonte).from('manual_foto_respostas').select('*'), escopo).maybeSingle(),
  );
}
